import { operatorClient } from 'domain/HttpClients';
import { END_POINT, MANAGERS_ROLES } from 'domain/fleets/constants';

export const updateFleet = async (fleetId, fleetName, fleetDescription) => {
  const response = await operatorClient
    .Patch(`/api/fleet/${fleetId}`)
    .withData({
      name: fleetName,
      description: fleetDescription,
    })
    .send();
  return response;
};
export const assignToManager = async (fleetId, manager) => {
  const response = await operatorClient
    .Put(`/api/fleet/${fleetId}/assign-manager/${manager}`)
    .send();
  return response;
};

export const assignToFleet = async (fleet, vehicleId, message) => {
  const response = await operatorClient
    .Patch('api/vehicles/assign-to-fleet')
    .withParams({
      enableValidation: false,
    })
    .withData({
      fleetId: fleet,
      vehicleIds: vehicleId,
      message,
    })
    .send();
  return response;
};

export const createFleet = async (fleetName, fleetDescription, courier, manager) => {
  const response = await operatorClient
    .Post('/api/fleet')
    .withData({
      name: fleetName,
      description: fleetDescription,
      accountId: courier,
      managerId: manager,
    })
    .send();
  return response;
};

export const getManagers = async () => {
  let allManagers = [];
  try {
    const response = await operatorClient
      .Get('/api/profiles/query')
      .withParams({ role: MANAGERS_ROLES })
      .send();
    if (response?.results) {
      allManagers = [...allManagers, ...response?.results];
    }

    let hasNext = response?.nextPage?.hasResults;
    let nextCursor = response?.nextPage?.cursor;
    while (hasNext) {
      const resp = await operatorClient
        .Get('/api/profiles/query')
        .withParams({ role: MANAGERS_ROLES, cursor: nextCursor })
        .send();
      if (resp?.results) {
        allManagers = [...allManagers, ...resp?.results];
      }
      hasNext = resp?.nextPage?.hasResults;
      nextCursor = resp?.nextPage?.cursor;
    }
    return allManagers;
  } catch (e) {
    console.error(e);
    return allManagers;
  }
};
export const getFleetByName = async (name, accountId = null) => {
  try {
    const response = await operatorClient
      .Get(END_POINT)
      .withParams({ includeNames: name, includeAccountIds: accountId })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getManagersByName = async (name) => {
  try {
    const response = await operatorClient
      .Get('/api/profiles/query')
      .withParams({ role: MANAGERS_ROLES, firstName: name })
      .send();
    const output = response.results.map((row) => ({
      value: row.profileId,
      label: row.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};
